import { RootState } from '@/App/store';

export const selectAppConfig = (state: RootState) => state.config;
